import { useSyncExternalStore } from 'react'
import { suscribirUbicacion, ubicacionActual, type Ubicacion } from './historial.js'

/**
 * Ubicación vigente, compartida por todas las vistas.
 *
 * Único punto de suscripción al historial. Para *cambiar* de ubicación se usa
 * `navegarA` o el componente `Enlace`; no hace falta un hook que envuelva las
 * dos cosas.
 */
export function useUbicacion(): Ubicacion {
  return useSyncExternalStore(suscribirUbicacion, ubicacionActual, ubicacionActual)
}
